"use client";

import { useLayoutEffect } from "react";

const SITE_NAME = "Libum Portal";

/**
 * Hook to set the document title for client components
 * @param title - The page title (will be appended with " | Libum Portal")
 */
export function useDocumentTitle(title: string) {
  useLayoutEffect(() => {
    document.title = `${title} | ${SITE_NAME}`;
  }, [title]);
}
